import axios from 'axios';

export function getAgent() {
  const token = window.localStorage.getItem('SessionToken');
  return axios({
    method: 'get',
    headers: { Authorization: `Token ${token}` },
    url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/self/`,
  })
    .then(res => res.data);
}

export function getShopper(username) {
  const token = window.localStorage.getItem('SessionToken');

  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/shopper/${username}/`,
    headers: { Authorization: `Token ${token}` },
  })
    .then(res => res.data);
}

export function updateShopper(username, data) {
  const token = window.localStorage.getItem('SessionToken');

  return axios({
    method: 'put',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/shopper/${username}/`,
    headers: { Authorization: `Token ${token}` },
    data,
  })
    .then(res => res.data);
}
